import { BaseStorage } from '../lib/index.mjs';

const getSessionStorage = (options) => {
  if (typeof window === "undefined" || !("sessionStorage" in window)) {
    return;
  }
  return new BaseStorage(sessionStorage, options);
};

export { getSessionStorage };
//# sourceMappingURL=index.mjs.map
